export const LEGAL_META =
  "Last updated: 2026.01.01 · Effective for all users of the Highwatch AI platform";

export const LEGAL_INTRO =
  "These Terms of Service (\"Terms\") govern access to and use of the Highwatch AI platform, including the Intelligence, Insurance, Finance, and Healthcare products (collectively, the \"Service\"), provided by";

const SECURITY_BODY =
  "Highwatch maintains SOC 2-aligned controls (Type I at launch, Type II on roadmap), AES-256 encryption at rest, and TLS 1.3 in transit, with architecture designed toward HIPAA, GDPR, NAIC, and EU AI Act readiness.";

const WARRANTY_BODY =
  "The Service is provided \"as is.\" Highwatch disclaims all implied warranties to the maximum extent permitted by law, including any warranty that AI-generated output will be error-free or suitable for a particular regulatory outcome.";

export const LEGAL_SECTIONS = [
  {
    title: "The Service",
    body:
      "Highwatch provides an enterprise intelligence platform that unifies organizational knowledge, automates operational workflows, and generates AI-assisted decision support — including risk scoring, fraud/severity detection, and explainability output — for customers in regulated industries.",
  },
  {
    title: "AI Output Is Decision Support, Not a Final Decision",
    body:
      "The Service uses AI models to generate risk scores, recommendations, and supporting evidence. This output is provided to assist your organization's own qualified personnel — it is not a substitute for professional, regulatory, or legal judgment. Your organization is solely responsible for reviewing AI-generated output before acting on it, and for any final underwriting, claims, or compliance decision made using the Service.",
  },
  {
    title: "Accounts & Roles",
    body:
      "Access to the Service is role-based (e.g., Underwriter, Claims Adjuster, Manager, Admin, Auditor). Your organization's administrator is responsible for assigning roles and permissions appropriately, and for all activity occurring under accounts they provision.",
  },
  {
    title: "Subscription, Fees & Payment",
    body: WARRANTY_BODY,
  },
  {
    title: "Customer Data",
    body:
      "As between you and Highwatch, you retain all rights to the data you submit to the Service (\"Customer Data\"). We process Customer Data solely to provide, secure, and improve the Service, as described in our Privacy Policy.",
  },
  {
    title: "Acceptable Use",
    lines: [
      "No attempt to reverse-engineer, probe, or bypass platform security or role-based access controls.",
      "No use of the Service to process data you are not legally authorized to process.",
      "No sharing of login credentials outside your organization's authorized users.",
    ],
  },
  {
    title: "Security",
    body: SECURITY_BODY,
  },
  {
    title: "Intellectual Property",
    body:
      "Highwatch retains all rights to the Service, its underlying models, and platform software. These Terms grant you a limited right to use the Service — not ownership of any part of it.",
  },
  {
    title: "Term & Termination",
    body: SECURITY_BODY,
  },
  {
    title: "Warranties & Disclaimers",
    body: WARRANTY_BODY,
  },
  {
    title: "Limitation of Liability",
    body: WARRANTY_BODY,
  },
  {
    title: "Governing Law",
    body: WARRANTY_BODY,
  },
  {
    title: "Changes to These Terms",
    body:
      "We may update these Terms from time to time. Material changes will be communicated to account administrators before taking effect.",
  },
  {
    title: "Contact",
    body: "Questions about these Terms:",
    isContact: true,
  },
];

